export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MESSAGES = "messages";
export const AUTH_URL = BASE_URL + "auth/local";
export const SHOPIFY_ACCESS_TOKEN = "5c08c7f290e432e9edf0d04e84ea329d";
export const SHOPIFY_DOMAIN = process.env.REACT_APP_SHOPIFY_URL;
export const SHOPIFY_API_VERSION = "2023-10";
